import { DeliveryCompany } from "../entity/DeliveryCompany";
import { StoreDeliveryConfigurations } from "../entity/StoreDeliveryConfiguration";

export const getConnectedDeliveryCompanies = (
  deliveryCompanies?: DeliveryCompany[],
  storeConfig?: StoreDeliveryConfigurations[],
): DeliveryCompany[] => {
  var res: DeliveryCompany[] = [];

  deliveryCompanies?.forEach((item) => {
    storeConfig?.forEach((config) => {
      if (item.id === config.companyId) {
        res.push(item);
      }
    });
  });

  return res;
};

export const getDeliveryCompanyImage = (
  company?: DeliveryCompany[],
  id?: string,
): string | undefined => {
  return company?.find((item) => item.id === id)?.logo;
};
